import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./Profile.css";
import { AiOutlineGlobal } from "react-icons/ai";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebook, FaPencilAlt, FaCheck } from "react-icons/fa";
import { IoPersonCircle } from "react-icons/io5";
import { FaCameraRetro } from "react-icons/fa6";
import Vendorlogs from "../Components/vendor_logs";
import {} from "react-icons/fa";
import Address from "../Components/USER/Address";

const Profile = ({
  vendor,
  fetchvendor,
  parsedLinks,
  profile,
  fetchProfileData,
  profileupdate,
}) => {
  // const initialData = {
  //   name: "Ramya",
  //   email: "ramya@gmail.com",
  //   phone: "1209754349",
  //   addressList: [
  //     {
  //       name: "Ramya",
  //       mobile: "9080245087",
  //       pincode: "600001",
  //       locality: "4th Street Ram Nagar , Velachery",
  //       address: "Saranjo ladies hostel",
  //       city: "Chennai",
  //       state: "Tamil Nadu",
  //       landmark: "",
  //       altPhone: "",
  //       addressType: "Home",
  //     },
  //   ],
  //   profilePic: img4,
  // };

  const [profileData, setProfileData] = useState({
    addressList: [],
  });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [formData, setFormData] = useState(null);
  // const [newAddress, setNewAddress] = useState(null);
  const dropdownRef = useRef(null);

  const fieldLabels = {
    name: "Name",
    mobile: "10-digit number",
    pincode: "Pincode",
    locality: "Locality",
    address: "Address (Area and street)",
    city: "City/District/Town",
    state: "Select State",
    landmark: "Landmark (optional)",
    altPhone: "Alternate phone (optional)",
  };

  // const [profileData, setProfileData] = useState(initialData);

  // const [editingIndex, setEditingIndex] = useState(null);
  // const [newAddress, setNewAddress] = useState(null);
  // const [formData, setFormData] = useState(null);
  // const [hoveredIndex, setHoveredIndex] = useState(null);

  // const handleAddressChange = (e) => {
  //   const { name, value } = e.target;
  //   const updated = { ...(newAddress || formData), [name]: value };
  //   newAddress ? setNewAddress(updated) : setFormData(updated);
  // };

  // const handleSubmitAddress = (e) => {
  //   e.preventDefault();
  //   if (newAddress) {
  //     setProfileData({
  //       ...profileData,
  //       addressList: [...profileData.addressList, newAddress],
  //     });
  //     setNewAddress(null);
  //   } else {
  //     const updatedList = [...profileData.addressList];
  //     updatedList[editingIndex] = formData;
  //     setProfileData({ ...profileData, addressList: updatedList });
  //     setEditingIndex(null);
  //     setFormData(null);
  //   }
  // };

  // const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setEditingIndex(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  // ==============================================================================

  const [popup, setPopup] = useState(false);
  const location = useLocation();

  const userData = JSON.parse(localStorage.getItem("vendorData") || "{}");

  const handleChooseFile = async (e, type) => {
    const formData = new FormData();
    formData.append("id", userData?.id);
    if (type === "new") {
      const file = e.target.files[0];
      if (file) {
        formData.append("profile", file);
      } else {
        alert("No file selected");
        return;
      }
    } else if (type === "remove") {
      formData.append("profile", "");
    }
    if (location.pathname === "/profile") {
      formData.append("type", "customer");
    } else {
      formData.append("type", "vendor");
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/profile_update.php`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success || data.status === "success") {
        setPopup(false);
        if (location.pathname === "/profile") {
          fetchProfileData();
        } else {
          fetchvendor();
        }
        alert(type === "new" ? "Profile updated!" : "Profile removed!");
      } else {
        alert("Action failed.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const Profile = async () => {
  //   const formData = new FormData();
  //   formData.append("id", "1");

  //   try {
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_BASEURL}/apis/customer/customer_show.php`,
  //       formData
  //     );

  //     if (res.data) {
  //       const profileData = res.data.data?.[0] || null;
  //       const addressData = res.data.add?.[0]?.ship_add || null;

  //       setProfile(profileData);
  //       setAddress(addressData);
  //     } else {
  //       console.warn("Empty or invalid response");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching profile:", err);
  //   }
  // };

  const profiledata = location.pathname === "/profile" ? profile : vendor;

  const profileUrl = profiledata?.profile
    ? `${process.env.REACT_APP_BASEURL}/apis/uploads/profile/${profiledata.profile}`
    : null;

  // const handleAddressChange = (e) => {
  //   const { name, value } = e.target;

  //   if (formData && editingIndex !== null) {
  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   } else if (newAddress) {
  //     setNewAddress({
  //       ...newAddress,
  //       [name]: value,
  //     });
  //   }
  // };

  // const handleSubmitAddress = (e) => {
  //   e.preventDefault();

  //   const updatedList = [...profileData.addressList];

  //   if (editingIndex !== null && formData) {
  //     updatedList[editingIndex] = formData;
  //   } else if (newAddress) {
  //     updatedList.push(newAddress);
  //   }

  //   setProfileData({
  //     ...profileData,
  //     addressList: updatedList,
  //   });

  //   setEditingIndex(null);
  //   setFormData(null);
  //   setNewAddress(null);
  // };

  // import React, { useState, useEffect } from "react";

  // const [addressData, setAddressData] = useState({});

  // const [existingTypes, setExistingTypes] = useState([]);
  // const [newLabel, setNewLabel] = useState("");
  // const [newValue, setNewValue] = useState("");
  // const MAX_ADDRESSES = 4;

  // useEffect(() => {
  //   try {
  //     const parsed = JSON.parse(profile.address);
  //     setAddressData(parsed);
  //     setExistingTypes(Object.keys(parsed)); // ['A1', 'A2']
  //   } catch (error) {
  //     console.error("Failed to parse address JSON:", error);
  //   }
  // }, [profile]);



  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(profiledata?.name || "");

  const handleEditClick = () => setIsEditing(true);
  const handleprofilesave = (action) => {
    setIsEditing(false);
    if (profileupdate) profileupdate(name, action);
  };

  return (
    <>
      <div className="profile-card">
        <div className="vendor-profile">
          <span className="vendor-p"> Personal Info</span>
        </div>
        <div className="profile-header">
          <div className="profile-photo-wrapper">
            {profiledata?.profile ? (
              <img className="profile-photo" src={profileUrl} alt="avatar" />
            ) : (
              <IoPersonCircle
                className="profile-photo"
                style={{ color: "#4b53c180" }}
              />
            )}

            <div
              className="upload-overlay"
              onClick={() => {
                setPopup(true);
              }}
            >
              <span className="upload-icon">
                <FaCameraRetro />
              </span>
            </div>
            {popup && (
              <div
                className="modal-overlay-acc"
                onClick={() => {
                  setPopup(false);
                }}
              >
                <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                  <p
                    className="modal-action"
                    onClick={() =>
                      handleChooseFile({ target: { files: [] } }, "remove")
                    }
                  >
                    Remove profile photo
                  </p>

                  <label className="modal-action upload-text">
                    Upload from device
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleChooseFile(e, "new")}
                    />
                  </label>
                </div>
              </div>
            )}
          </div>

          <div className="profile-info">
            <div className="profile-name-container">
              {isEditing ? (
                <div className="edit-mode">
                  <input
                    className="name-input"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <button
                    className="icon-button"
                    onClick={() => handleprofilesave("update")}
                  >
                    <FaCheck />
                  </button>
                </div>
              ) : (
                <div className="display-mode">
                  <h2 className="profile-name">{name || profile?.name}</h2>
                  <button className="icon-button" onClick={handleEditClick}>
                    <FaPencilAlt />
                  </button>
                </div>
              )}
            </div>
            <div className="profile-social1">
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Email:</strong> {profiledata?.email}
              </p>

              <p className="ss" style={{ margin: "3px" }}>
                <strong>Phone:</strong> {profiledata?.phone_no}
              </p>

              {location.pathname !== "/profile" && (
                <p className="ss" style={{ margin: "3px" }}>
                  <strong>Office Location:</strong> {vendor?.address}
                </p>
              )}
            </div>
          </div>
        </div>

        {location.pathname !== "/profile" && (
          <>
            <div className="separator3" />
            <div>
              <h3
                style={{
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  color: "lightcoral",
                }}
              >
                Store Details
              </h3>
              <p className="ss">
                <strong>Store Name:</strong> {vendor?.store_name}
              </p>

              <p className="ss">
                <strong>GST No:</strong> {vendor?.gst_no}
              </p>

              <p className="ss">
                <strong>Pickup Location:</strong> {vendor?.pickup_add}
              </p>
              <div className="separator3" />

              <h3
                style={{
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  color: "lightcoral",
                }}
              >
                Bank Details
              </h3>

              <p className="ss">
                <strong>Bank Holder Name:</strong> {vendor?.acc_holder_name}
              </p>

              <p className="ss">
                <strong>Bank Acc/No:</strong> {vendor?.acc_no}
              </p>

              <p className="ss">
                <strong>IFSC Code:</strong> {vendor?.ifsc}
              </p>

              <div className="separator3" />
            </div>
            <div className="login-activity">
              <Vendorlogs />
            </div>

            <div className="profile-social">
              {parsedLinks?.w && (
                <>
                  <a
                    title="Website URL"
                    href={parsedLinks.w}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiOutlineGlobal />
                  </a>{" "}
                  |{" "}
                </>
              )}
              {parsedLinks?.i && (
                <>
                  <a
                    title="Instagram"
                    href={parsedLinks.i}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <RiInstagramFill />
                  </a>{" "}
                  |{" "}
                </>
              )}
              {parsedLinks?.f && (
                <>
                  <a
                    title="Facebook"
                    href={parsedLinks.f}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook />
                  </a>
                </>
              )}
            </div>
          </>
        )}

        {location.pathname === "/profile" && (
          <div className="profile-section">
            <div
              style={{
                maxWidth: "500px",
                margin: "0 auto",
                fontFamily: "Arial",
              }}
            >
              {/* <h2>Saved Addresses</h2> */}

              {/* {existingTypes.length === 0 && <p>No addresses saved.</p>}

              {existingTypes.map((type, index) => {
                const label = Object.keys(addressData[type] || {})[0]; // "home" or "work"
                const value = addressData[type]?.[label]; // actual address

                return (
                  <div
                    key={index}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <strong style={{ textTransform: "capitalize" }}>
                        {label}
                      </strong>
                      <p style={{ margin: "5px 0" }}>{value}</p>
                    </div>

                    <button
                      style={{
                        backgroundColor: "red",
                        color: "#fff",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDelete(type, "delete")}
                    >
                      Delete
                    </button>
                  </div>
                );
              })}

              {existingTypes.length < MAX_ADDRESSES ? (
                <div
                  style={{
                    marginTop: "20px",
                    padding: "10px",
                    border: "1px dashed #ccc",
                    borderRadius: "5px",
                  }}
                >
                  <h4>Add New Address</h4>

                  <select
                    value={newLabel}
                    onChange={(e) => setNewLabel(e.target.value)}
                    style={{ marginRight: "10px", padding: "5px" }}
                  >
                    <option value="">Select Label</option>
                    <option value="home">Home</option>
                    <option value="work">Work</option>
                    <option value="others">Others</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Address"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px", padding: "5px" }}
                  />
                  <button
                    onClick={handleAdd}
                    style={{
                      backgroundColor: "#28a745",
                      color: "#fff",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Add Address
                  </button>
                </div>
              ) : (
                <p style={{ color: "gray", marginTop: "20px" }}>
                  You’ve reached the maximum of 4 addresses.
                </p>
              )} */}

              <Address profileupdate={profileupdate} profile={profile} />
              <hr />

              {/* {canAddMore ? (
                <>
                  <h3>Add New Address</h3>
                  <div style={{ marginBottom: "10px" }}>
                    <label>Type: </label>
                    <select
                      name="type"
                      value={newAddress.type}
                      onChange={handleChange}
                    >
                      <option value="">-- Select --</option>
                      {ADDRESS_TYPES.map(
                        (type) =>
                          !addressData[type] && (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          )
                      )}
                    </select>
                  </div>

                  <div style={{ marginBottom: "10px" }}>
                    <label>Address: </label>
                    <input
                      type="text"
                      name="value"
                      value={newAddress.value}
                      onChange={handleChange}
                      placeholder="Enter address"
                      style={{ width: "100%", padding: "6px" }}
                    />
                  </div>

                  <button
                    onClick={handleAddAddress}
                    style={{
                      backgroundColor: "#2563eb",
                      color: "#fff",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Save Address
                  </button>
                </>
              ) : (
                <p style={{ color: "gray", marginTop: "20px" }}>
                  Maximum 4 addresses reached.
                </p>
              )} */}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;
